import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  border-bottom: 1px solid #d8d8d8;
  width: 91%;
  height: 16.2%;
  flex-direction: column;

  .progress-bar {
    transform: rotate(180deg);
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: #141519;
  font-size: 4.6vh;
  height: 90%;
`;

export const LogoContainer = styled.div``;
